/**
 * Hosts we intentionally allow to receive the `Referer` header when linked to
 * externally. For these destinations we keep `noopener` (security) but drop
 * `noreferrer`, so they can attribute incoming traffic to this site. Every
 * other external link keeps `noreferrer`. Each host is matched exactly (it may
 * itself be a subdomain, e.g. `play.timeline.com`) plus any of its subdomains,
 * so e.g. both `mitopure.com` and `www.mitopure.com` qualify.
 */
export const REFERRER_ALLOWED_HOSTS = [
  'play.timeline.com',
  'pro.timeline.com',
  'mitopure.com',
];
